import { render, staticRenderFns } from "./DropdownOptionDialog.vue?vue&type=template&id=c0865a7a&scoped=true"
import script from "./DropdownOptionDialog.vue?vue&type=script&lang=js"
export * from "./DropdownOptionDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0865a7a",
  null
  
)

export default component.exports